import { KbColor } from '@models/classes/primitives/kb-color';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { IColorFillTextureLayer } from '../kb3d-models';
import { Token } from '../token';
import { TextureLayer } from './texture-layer';

@Kb3dModel<ColorFillTextureLayer>({
    token: Token.ColorFillTextureLayer,
})
export class ColorFillTextureLayer extends TextureLayer implements IColorFillTextureLayer {
    color: KbColor;

    width: number;
    height: number;
}
